import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';
import ErrorUtils from 'utils/error-utils';

export const getVenue = id => {
    return APIUtils.get(`/destinations/${id}/event-packages/`)
        .then(response => {
            try {
                return ObjectUtils.camelizeKeys(response.data.data);
            } catch (error) {
                return Promise.reject(new Error('Response shape unexpected.'));
            }
        })
        .catch(error => {
            ErrorUtils.sendSentryError(error);

            return Promise.reject(new Error(error));
        });
};
